import type { JSX } from 'react';
import type { IChartLaneLogScale } from '@/types/PatientDashboard/PatientTimeline.types';
import { ChartLaneYAxis, ChartLaneYAxisLabel } from './ChartLane.styles';
import { formatChartLaneTick, yLogPct } from './ChartLane.util';

interface IProps {
  scale: IChartLaneLogScale;
}

export default function ChartLaneYAxisTicks({ scale }: IProps): JSX.Element {
  return (
    <ChartLaneYAxis>
      {scale.ticks.map((tick) => (
        <ChartLaneYAxisLabel key={tick} style={{ top: `${yLogPct(tick, scale)}%` }}>
          {formatChartLaneTick(tick, scale)}
        </ChartLaneYAxisLabel>
      ))}
    </ChartLaneYAxis>
  );
}
